import script from "./item-card.vue?vue&type=script&setup=true&lang=js"
export * from "./item-card.vue?vue&type=script&setup=true&lang=js"

import "./item-card.vue?vue&type=style&index=0&id=e0afd676&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0afd676"]])

export default __exports__